export default "__VITE_ASSET__Cso2gMi4__"